/**
 * @module getQueryParameterByName
 * @export {Function}
 */

/**
 * Fetches a named query parameter from the window.location object
 * @param  {String} name The name of the query parameter you want to fetch
 * @return {String}      The value of the query parameter you want to fetch
 */
function getQueryParameterByName( name ) {
    //eslint-disable-next-line
    name = name.replace(/[\[]/, "\\[").replace(/[\]]/, "\\]");
    const regex = new RegExp("[\\?&]" + name + "=([^&#]*)");
    const results = regex.exec( window.location.search );
    return results === null ? "" : decodeURIComponent(results[1].replace(/\+/g, " "));
}

export default getQueryParameterByName;


// WEBPACK FOOTER //
// ./src/utils/getQueryParameterByName.js